import * as React from 'react';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
import { useList_unstable } from './useList';
import { renderList_unstable } from './renderList';
import { useListStyles_unstable } from './useListStyles.styles';
import { useListContextValues_unstable } from './useListContextValues';
export const List = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useList_unstable(props, ref);
    const contextValues = useListContextValues_unstable(state);
    useListStyles_unstable(state);
    useCustomStyleHook_unstable('useListStyles_unstable')(state);
    return renderList_unstable(state, contextValues);
});
List.displayName = 'List';
